import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Textarea,
  useToast,
  Heading,
} from "@chakra-ui/react";
import { DarkMode } from "@chakra-ui/react";
const DepressionDiagnoser = () => {
  const [answers, setAnswers] = useState({});
  const [depression, setdepression] = useState(false);
  const toast = useToast();
  let dep = 0;
  const handleSubmit = () => {
    // Perform diagnosis based on answers and additionalInfo
    const diagnosisResult =
      "You should consult a doctor about a mental health condition.";

    // Display diagnosis result
    toast({
      title: "Diagnosis Result",
      description: diagnosisResult,
      status: "error",
      duration: 5000,
      isClosable: true,
    });
  };

  return (
    <div style={{ backgroundColor: "#1A202C" }}>
      <DarkMode>
        <Box maxW="md" mx="auto" py={6}>
          <Heading as="h1" mb={4} color={"white"}>
            Depression Diagnoser
          </Heading>

          <form>
            <Question question="Have you been feeling down, sad, or hopeless most of the time for the past few weeks?" />
            <Question question="Do you often experience excessive worry, anxiety, or nervousness that is difficult to control?" />
            <Question question="Have you had any thoughts of self-harm or suicide?" />
            <Question question="Do you frequently have difficulty concentrating or making decisions?" />
            <Question question="Are you experiencing significant changes in appetite or weight?" />

            <Button colorScheme="blue" onClick={handleSubmit}>
              Diagnose
            </Button>
          </form>
        </Box>
      </DarkMode>
    </div>
  );
};

function Question({ question }) {
  return (
    <div style={{ backgroundColor: "#1A202C" }}>
      <div>
        <FormControl id="question1" mb={4}>
          <FormLabel color={"white"}>{question}</FormLabel>
          <RadioGroup>
            <Stack direction="row">
              <Radio value="option1">
                <h3 style={{ color: "white" }}>Yes</h3>
              </Radio>
              <Radio value="option2" style={{ color: "white" }}>
                <h3 stlye={{ color: "white" }}>No</h3>
              </Radio>
            </Stack>
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
}

export default DepressionDiagnoser;
